const addCookieCheckboxes = () => {
	const modal = document.querySelector('.cky-modal');
	if (!modal) return;

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'class' &&
				modal.classList.contains('cky-modal-open')
			) {
				const headers = modal.querySelectorAll('.cky-accordion-header');
				headers.forEach((header) => {
					if (!header.querySelector('.cky-switch')) {
						const switchElement = document.createElement('div');
						switchElement.classList.add('cky-switch');
						switchElement.setAttribute(
							'data-cky-tag',
							'detail-category-toggle'
						);
						switchElement.innerHTML =
							'<input type="checkbox" disabled checked id="ckySwitchfunctional" aria-label="Enable Functional" autocomplete="off" style="background-color: rgb(208, 213, 210);">';
						header.appendChild(switchElement);
					}
				});
			}
		});
	});

	observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
};

const changeCookieCloseImg = () => {
	const closeImage = document.querySelector('.cky-btn-close img');

	if (closeImage) {
		closeImage.src =
			'data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%2015L15%201%22%20stroke%3D%22%23181B2B%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M15%2015L1%201%22%20stroke%3D%22%23181B2B%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3C%2Fsvg%3E';
	}
};

export const handleCookieCheckboxes = () => {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.addedNodes.length) {
				mutation.addedNodes.forEach((node) => {
					if (
						node.nodeType === 1 &&
						node.classList.contains('cky-modal')
					) {
						addCookieCheckboxes();
						changeCookieCloseImg();
					}
				});
			}
		});
	});

	observer.observe(document.body, { childList: true, subtree: true });
};
